export default __webpack_public_path__ + "static/media/jaipur4.61311620.jpg";